// extracted by mini-css-extract-plugin
export var defaultWrapper = "_le-3";
export var downloadButton = "_le-4";
export var fileContainer = "_le-9 _le-7";
export var fileContainerBase = "_le-7";
export var fileContainerFixedHeight = "_le-8 _le-7";
export var fileInfo = "_le-5";
export var fileInfoWidthRestricted = "_le-6";
export var fileType = "_le-1";
export var fileTypeName = "_le-2";
export var image = "_le-0";
export var link = "_le-b";
export var overflowEllipsis = "_le-a";